import { render, staticRenderFns } from "./RolePanel.vue?vue&type=template&id=63b8c9d4&scoped=true"
import script from "./RolePanel.vue?vue&type=script&lang=js"
export * from "./RolePanel.vue?vue&type=script&lang=js"
import style0 from "./RolePanel.vue?vue&type=style&index=0&id=63b8c9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8c9d4",
  null
  
)

export default component.exports